import React, { useEffect, useState } from 'react'
import { MiniLoader } from './MiniLoader'
import Box from '@mui/material/Box'

interface FallbackIndicatorProps {
  delay?: number
}

export const FallbackIndicator: React.FC<FallbackIndicatorProps> = (props) => {
  const { delay = 500 } = props
  const [ show, setShow ] = useState(false)

  useEffect(() => {
    setTimeout(() => setShow(true), delay)

    return () => setShow(false)
  }, [])
 
  return (
    <>
      {show &&
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' height='100%'>
          <MiniLoader size={48} fill='dark' />
        </Box>
      }
    </>
  )
}